/* eslint-disable @typescript-eslint/naming-convention */
import { canUseDOM } from '@ps/web-core-utils';
import type { Page, Website } from '@ps/web-martech-cms-types';
import { camelCase } from 'lodash';
import URL from 'url-parse';

import { select } from '../../../index';
import type { EffectParams, RootState } from '../../types';

import type { Alias, RoutesResponse, WebsiteResponse } from './cms';

// TODO: CMS-migration - remove after stack content can be modified
export const defaultLayout = {
  layout_type: 'StarsLayout' as Page['layout']['layout_type'],
  background_image: undefined,
  background_color: '',
  background_fit: null
};
// TODO: CMS-migration - end

export const requestOverride = {
  timeout: 20000,
  retry: {
    count: 3
  }
};

interface SessionResponse {
  legalAge: Website['legal_age'];
}

const effects = {
  async fetchWebsite(payload: undefined, { request, dispatch, rootState }: EffectParams) {
    const payloadBody = getRequestPayload(select.location.getHref(rootState), rootState);
    if (payloadBody.siteId === 'isp') delete payloadBody.siteId;
    const [{ body: website }, { body: routes }] = await Promise.all([
      request<WebsiteResponse>({
        service: '/api/v1-preview/cms/website',
        ...requestOverride
      }),
      // TODO: CMS-migration - remove request to routes after all verticals are on ContentStack
      request<RoutesResponse>({
        service: '/api/v1-preview/cms/routes',
        body: payloadBody
      })
    ]);

    if (website) {
      // TODO: CMS-migration - legal_age should be a part of Website entry in ContentStack
      // remove request to session after ContentStack migration
      if (!website.website.legal_age) {
        const {
          body: { legalAge }
        } = await request<SessionResponse>({ service: 'session.info' });

        website.website.legal_age = legalAge;
      }

      // TODO: CMS-migration - aliases should be fixed on the middle tier,
      // fix the redirect logic in StarsPage.tsx
      const routesWithAliasKeys = Object.fromEntries(
        Object.entries(routes).map(([key, value]) => [
          camelCase(key),
          value.replace('/casino/help/', '/help/')
        ])
      );
      website.aliases = {
        ...(routesWithAliasKeys as Partial<{ [key in Alias]: string }>),
        ...website.aliases
      };
    }

    dispatch.cms.setWebsite(website);
  }

  // TODO: Add fetchPage, loadModel, prepare, preload when they are required.
};
export default effects;

export const getRequestPayload = (href: string, rootState: RootState) => {
  const url = new URL(href, true);
  const { pathname, query } = url;
  const path = select.location.stripBaseURL(rootState, pathname);
  const locationQuery = select.location.getQuery(rootState);
  const siteId = query.siteId || locationQuery.siteId;
  const { clientVersion } = select.localSettings.get(rootState);
  return {
    path,
    clientVersion: canUseDOM ? window.version : clientVersion,
    siteId
  };
};
